import type { FaireProductEntity } from "../../entity_types/product";

export const p_x3xsb27ugm: FaireProductEntity = {
  token: "p_x3xsb27ugm",
  type: "product",
  name: "Butter Squishy Toy – Slow Rise (5.5”) MSUSB",
  brandToken: "b_yffkzrfy9m",
  brandName: "Modek Sports",
  imageUrl:
    "https://cdn.faire.com/fastly/49559ba14d9bcc3e7c7ed9d081f9854a9529c04cf0053619be1b69cdb6524600.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e64063277368e79a7f9bbdc122bfe255c1fdf9599ef2e2a916002a605e14090.png",
    "https://cdn.faire.com/fastly/658e4a2d296890a53fd9b7ac5d86503c53dac543e470a91ef00b12bb615b64a5.png",
    "https://cdn.faire.com/fastly/94d9d4768937ea77091b4cae7cb37b37b70f667d19cdbb22cd74074843a2bf48.png",
  ],
  priceDollars: 4.25,
  description:
    "Butter Squishy Toy – Slow Rise (5.5”)\n\n\n\n\nBring a fun twist to your toy lineup with this realistic 5.5” butter squishy toy. Designed to look just like a stick of butter, this eye-catching piece combines novelty appeal with satisfying sensory play, making it a guaranteed attention grabber on any shelf.\n\n\n\n\nMade from soft, squeezable material, this butter squishy delivers a smooth slow-rise effect that customers love. Perfect for stress relief, fidgeting, and impulse purchases, it appeals to both kids and adults looking for something fun and unique.\n\n\n\n\nIts clean, realistic design makes it stand out from typical squishies, offering a simple but highly effective product that sells.\n\n\n\n\nProduct Features:\n\n• Size: 5.5” butter stick\n\n• Soft squeezy, slow-rise material\n\n• Realistic butter design with printed detail\n\n• Smooth, satisfying squeeze effect\n\n• Great for stress relief and fidget play\n\n• Strong impulse buy item\n\n• Ideal for toy stores, gift shops, beach shops, and boardwalk locations\n\n\n\n\nPackaging:\n\n• Individually wrapped\n\n• Available in retail display packaging\n\n• Perfect for countertop merchandising\n\n\n\n\nA simple, high-converting novelty item that combines realism with satisfying play, making it an easy addition to any best-selling toy selection.\n",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:37.165Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
